import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import Icon from '../Icon';
export default function ModalCloseButton(t0) {
  const $ = _c(8);
  const {
    onClick,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("absolute top-6 right-6 z-10 p-2.5 text-brown-700", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClick) {
    t2 = e => {
      e.stopPropagation();
      onClick?.(e);
    };
    $[2] = onClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon name="cross" className="text-inherit" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2) {
    t4 = <button data-testid="ModalCloseButton" type="button" className={t1} onClick={t2}>{t3}</button>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}